// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ea5f2976","455":"2c78f284","977":"fd2f8310"}[chunkId] + ".chunk.js";
};